export default __webpack_public_path__ + "static/media/IMG_0184.4ae6501c.jpg";